// Currency Types and Constants

export type CurrencyCode = "EUR" | "USD" | "GBP" | "CAD" | "AUD";

export interface CurrencyInfo {
    code: CurrencyCode;
    name: string;
    symbol: string;
    flag: string;
    locale: string;
}

export const CURRENCIES: readonly CurrencyInfo[] = [
    { code: "EUR", name: "Euro", symbol: "€", flag: "🇪🇺", locale: "it-IT" },
    {
        code: "GBP",
        name: "British Pound",
        symbol: "£",
        flag: "🇬🇧",
        locale: "en-GB",
    },
    {
        code: "USD",
        name: "US Dollar",
        symbol: "$",
        flag: "🇺🇸",
        locale: "en-US",
    },
    {
        code: "CAD",
        name: "Canadian Dollar",
        symbol: "$",
        flag: "🇨🇦",
        locale: "en-CA",
    },
    {
        code: "AUD",
        name: "Australian Dollar",
        symbol: "$",
        flag: "🇦🇺",
        locale: "en-AU",
    },
] as const;

export const DEFAULT_CURRENCY: CurrencyCode = "USD";

export const CURRENCY_STORAGE_KEY = "selectedCurrency";

// Helper per validare currency code
export const isValidCurrency = (code: string): code is CurrencyCode => {
    return CURRENCIES.some(c => c.code === code);
};

// Helper per ottenere info currency
export const getCurrencyInfo = (
    code: CurrencyCode
): CurrencyInfo | undefined => {
    return CURRENCIES.find(c => c.code === code);
};
